import { useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { useCourses } from "@/components/home/ProgrammesPreview";
import { fmtSession } from "@/lib/dates";

const field = "rounded-xl border border-ink/20 bg-white/70 px-3 py-2.5 text-sm focus:border-ochre focus:outline-none";
const empty = { course_slug: "", date: "", start_time: "10:00", end_time: "12:00", location: "" };

export const SessionsAdmin = ({ sessions, reload }) => {
  const courses = useCourses();
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const add = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/admin/sessions", f); toast.success("Session added"); setF({ ...empty, course_slug: f.course_slug }); reload(); }
    catch (err) { toast.error(formatError(err)); } finally { setBusy(false); }
  };
  const remove = async (id) => {
    try { await api.delete(`/admin/sessions/${id}`); toast.success("Session removed"); reload(); } catch (err) { toast.error(formatError(err)); }
  };

  return (
    <div>
      <form onSubmit={add} data-testid="admin-session-form" className="grid gap-3 rounded-2xl bg-white/60 p-5 md:grid-cols-8">
        <select required data-testid="admin-session-course" value={f.course_slug} onChange={set("course_slug")} className={`${field} md:col-span-2`}>
          <option value="">Choose programme…</option>
          {courses.map((c) => <option key={c.slug} value={c.slug}>{c.title}</option>)}
        </select>
        <input required type="date" data-testid="admin-session-date" value={f.date} onChange={set("date")} className={field} />
        <div className="flex gap-2 md:col-span-2">
          <input required type="time" data-testid="admin-session-start" value={f.start_time} onChange={set("start_time")} className={`${field} w-full`} />
          <input type="time" data-testid="admin-session-end" value={f.end_time} onChange={set("end_time")} className={`${field} w-full`} />
        </div>
        <input data-testid="admin-session-location" value={f.location} onChange={set("location")} placeholder="Location (optional)" className={`${field} md:col-span-2`} />
        <button disabled={busy} data-testid="admin-session-add" className="btn-ochre justify-center py-2.5 disabled:opacity-60">{busy ? "Adding…" : "Add session"}</button>
      </form>
      <div className="mt-4 overflow-hidden rounded-2xl bg-white/60" data-testid="admin-sessions-list">
        {!sessions.length && <p className="px-5 py-10 text-sm text-ink/60">No upcoming sessions yet.</p>}
        {sessions.map((s) => (
          <div key={s.id} className="flex items-center justify-between gap-4 border-b border-ink/10 px-5 py-4 last:border-0">
            <div>
              <p className="font-semibold">{s.course_title}</p>
              <p className="text-sm text-ink/70">{fmtSession(s)}{s.location ? ` · ${s.location}` : ""}</p>
            </div>
            <button data-testid={`admin-session-delete-${s.id}`} onClick={() => remove(s.id)} className="rounded-full p-2 text-ink/60 transition-colors hover:bg-ochre/10 hover:text-ochre" aria-label="Delete session"><Trash2 className="h-4 w-4" /></button>
          </div>
        ))}
      </div>
    </div>
  );
};
